// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
module.exports = require('@atlassian/trello-error-ext')(
  'Attachment::LimitExceeded',
);
